module.exports = __webpack_public_path__ + "img/图片16.f0201247.png";